'use strict';

var GridToolbarConfigurationEntityDirective = function GridToolbarConfigurationEntityDirective(App) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-entity.html'),
    controller: 'GridToolbarConfigurationEntityController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
      scope.$on('grid:celldoubleclick', function (event, args, gridId) {
        if (gridId === 'configuration-entity') {
          scope.onCellDoubleClick(args);
        }
      });
      scope.$on('grid:cellValueChanged', function () {
        scope.gridCellValueChanged = true;
      });
      scope.$on('configuration-entity:saveSuccess', function () {
        scope.gridCellValueChanged = false;
        scope.updateData(App.entities);
      });
    }
  };
};
GridToolbarConfigurationEntityDirective.$inject = ['App'];
module.exports = GridToolbarConfigurationEntityDirective;